export default {
  selectedPayment: {
    payment_type: 'va_number',
    bank_transfer: {
      bank: 'bsi'
    },
    va_number: {
      bank: 'bsi',
      va_number: '8578000000111111'
    },
    emoney: {
      payment_type: 'gopay'
    },
    credit_card: {
      token_id: null,
      authentication: true
    }
  },
  transactionPayment: null,
  transactionTypes: null,
  transactionHistory: null,
  transactionProduct: null,
  nominalZafit: []
}